import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9480bab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "节日推荐", -1))
const _hoisted_3 = { style: {"width":"100%","overflow":"hidden"} }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "filter-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "裂变玩法", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "filter-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "使用目的", -1))
const _hoisted_13 = { style: {"width":"100%","overflow":"hidden"} }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "filter-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "行业", -1))
const _hoisted_17 = { style: {"width":"100%","overflow":"hidden"} }
const _hoisted_18 = ["onClick"]

import {reactive, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {CalendarFilled, FieldTimeOutlined} from "@ant-design/icons-vue";
import {
  ITemplate,
  tagsFestivalDate,
  tagsFestival,
  tagsModel,
  tagsTarget, tagsTool, tagsIndustryGroup
} from "@/app/templates/index";
import BlockView from "@/components/block/BlockView.vue";
import ScrollPagerView from "@/components/ScrollPagerView.vue";
import dayjs from "dayjs";
import TemplateCardView from "@/app/templates/TemplateCardView.vue";
import {account} from "@/app/login";

interface IQuery {
  [key: string]: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTemplates',
  props: {
    templates: {}
  },
  setup(__props: any) {


const router = useRouter()
const route = useRoute()
const props = __props

const info = reactive({
  filter: {sort: {value: '推荐排序', items: ['推荐排序', '最新上架', '使用最多']}},
  masterFilter: {value: '全部', items: ['全部', '在线', '离线', '主题不足']},
  festivalScroll: {offset: 0, left: false, right: true},
  menu: {festival: '', model: '', tool: '', industry: '', target: ''} as IQuery,
  page: {data: [] as ITemplate[]},
  loading: false
})

const computeData = (templates: ITemplate[]) => {
  const festivalTags = Object.keys(tagsFestivalDate).filter(d => tagsFestivalDate[d].isAfter(dayjs().add(-7, 'days')))
  info.page.data = templates.filter(x => {
    return route.query.festival ? x.tags.includes(route.query.festival as string) : true
  }).filter(x => {
    if (!account.user?.is_master) return true
    switch (info.masterFilter.value) {
      case '全部':
        return true
      case '在线':
        return x.is_active
      case '离线':
        return !x.is_active
      default:
        return (x.theme_count ?? 0) < 4
    }
  }).filter(x => {
    return route.query.model ? x.tags.includes(route.query.model as string) : true
  }).filter(x => {
    return route.query.tool ? x.tags.includes(route.query.tool as string) : true
  }).filter(x => {
    return route.query.target ? x.tags.includes(route.query.target as string) : true
  }).filter(x => {
    return route.query.industry ? x.tags.find(i => tagsIndustryGroup[route.query.industry as string].tags.includes(i)) : true
  }).sort((a, b): number => {
    if (info.filter.sort.value == '推荐排序') {
      if (a.tags == null) return 1
      else if (b.tags == null) return -1
      const x = a.tags.find(t => festivalTags.includes(t))
      if (!x) return 1
      const y = b.tags.find(t => festivalTags.includes(t))
      if (!y) return -1
      if (tagsFestivalDate[x] == tagsFestivalDate[y]) return a.create_at > b.create_at ? -1 : a.create_at == b.create_at ? 0 : 1
      else return tagsFestivalDate[x].isAfter(tagsFestivalDate[y]) ? 1 : -1
    } else if (info.filter.sort.value == '最新上架') return a.create_at > b.create_at ? -1 : a.create_at == b.create_at ? 0 : 1
    else if (info.filter.sort.value == '使用最多') return a.use_count > b.use_count ? -1 : a.use_count == b.use_count ? 0 : 1
    else return 0
  })
}

const initQuery = () => {
  info.menu.festival = typeof route.query.festival == 'object' ? route.query.festival?.[0] as string : route.query.festival
  info.menu.model = typeof route.query.model == 'object' ? route.query.model?.[0] as string : route.query.model
  info.menu.tool = typeof route.query.tool == 'object' ? route.query.tool?.[0] as string : route.query.tool
  info.menu.industry = typeof route.query.industry == 'object' ? route.query.industry?.[0] as string : route.query.industry
  info.menu.target = typeof route.query.target == 'object' ? route.query.target?.[0] as string : route.query.target
  computeData(props.templates)
}

watch(() => props.templates, initQuery)
const onSegmentChange = () => computeData(props.templates)

const onMenuClick = (group: string[], key: string) => {
  group.forEach(g => {
    if (g == 'target') info.menu.festival = ''
    else if (g == 'festival') info.menu.target = ''
    if (g == 'industry') window.localStorage.industry = key
    info.menu[g] = key
  })
  let query = JSON.parse(JSON.stringify(info.menu))
  for (let key in query) {
    if (query[key] == '') delete query[key]
  }
  router.push({path: '/', query})
}


return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_segmented = _resolveComponent("a-segmented")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createBlock(BlockView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass(["item", {'active':!info.menu.festival}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onMenuClick(['festival'],'')))
        }, [
          _createVNode(_unref(CalendarFilled))
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ScrollPagerView, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: 16 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(tagsFestivalDate)).filter(d => _unref(tagsFestivalDate)[d].isAfter(_unref(dayjs)().add(-7,'days'))), (key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["festival", {'active':info.menu.festival===key}]),
                      key: key,
                      onClick: ($event: any) => (onMenuClick(['festival'],key))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, _toDisplayString(_unref(tagsFestival)[key]), 1),
                        _createElementVNode("div", null, _toDisplayString(`${_unref(tagsFestivalDate)[key].format('MM.DD')} 周${['日', '一', '二', '三', '四', '五', '六'][_unref(tagsFestivalDate)[key].day()]}`), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(FieldTimeOutlined)),
                        _createTextVNode(" " + _toDisplayString(Math.round((_unref(tagsFestivalDate)[key].valueOf() - new Date().valueOf()) / 24 / 3600 / 1000) > 0 ? Math.round((_unref(tagsFestivalDate)[key].valueOf() - new Date().valueOf()) / 24 / 3600 / 1000) + '天后' : ''), 1)
                      ])
                    ], 10, _hoisted_4))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", {
          class: _normalizeClass(["item", {'active':!info.menu.model && !info.menu.tool}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onMenuClick(['model','tool'],'')))
        }, "全部 ", 2),
        _createVNode(_component_a_space, { size: 16 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagsModel), (v, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["item", {'active':info.menu.model==key}]),
                key: key,
                onClick: ($event: any) => (onMenuClick(['model'],key))
              }, _toDisplayString(v), 11, _hoisted_9))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagsTool), (v, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["item", {'active':info.menu.tool==key}]),
                key: key,
                onClick: ($event: any) => (onMenuClick(['tool'],key))
              }, _toDisplayString(v), 11, _hoisted_10))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", {
          class: _normalizeClass(["item", {'active':!info.menu.target && !info.menu.festival}]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onMenuClick(['target'],'')))
        }, " 全部 ", 2),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(ScrollPagerView, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: 16 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagsTarget), (m, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["item", {'active':info.menu.target==key}]),
                      key: key,
                      onClick: ($event: any) => (onMenuClick(['target'],key))
                    }, _toDisplayString(m), 11, _hoisted_14))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", {
          class: _normalizeClass(["item", {'active':!info.menu.industry}]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (onMenuClick(['industry'],'')))
        }, " 全部 ", 2),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(ScrollPagerView, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: 16 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagsIndustryGroup), (m, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["item", {'active':info.menu.industry==key}]),
                      key: key,
                      onClick: ($event: any) => (onMenuClick(['industry'],key))
                    }, _toDisplayString(m.name), 11, _hoisted_18))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_a_flex, {
        justify: "space-between",
        align: "flex-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_segmented, {
                value: info.filter.sort.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((info.filter.sort.value) = $event)),
                options: info.filter.sort.items,
                size: "large",
                onChange: onSegmentChange
              }, null, 8, ["value", "options"]),
              (_unref(account).user?.is_master)
                ? (_openBlock(), _createBlock(_component_a_segmented, {
                    key: 0,
                    value: info.masterFilter.value,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((info.masterFilter.value) = $event)),
                    options: info.masterFilter.items,
                    size: "large",
                    onChange: onSegmentChange
                  }, null, 8, ["value", "options"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography_text, { type: "secondary" }, {
            default: _withCtx(() => [
              _createTextVNode("共计：" + _toDisplayString(info.page.data.length) + "个模板", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_list, {
        "data-source": info.page.data,
        grid: {gutter:12, md:2,lg:2,xl:3,xxl:4},
        pagination: {pageSize:48,showSizeChanger: false},
        class: "template-list"
      }, {
        renderItem: _withCtx(({item}) => [
          _createVNode(_component_a_list_item, { style: {"padding":"0"} }, {
            default: _withCtx(() => [
              _createVNode(TemplateCardView, { tpl: item }, null, 8, ["tpl"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _: 1
  }))
}
}

})